import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Button, Grid2, Typography, Tooltip, Box } from '@mui/material';
import { SelectField} from 'components';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { VTKDataRefreshAction  } from '../actions/DataManagementActions';
import { enqueueSnackbar } from 'actions';

const VTKDataRefreshForm = () => {
	const userId = useSelector(state => state.session.user.id);
	const dispatch = useDispatch();
	const [fileName, setFileName] = useState('');
	const [selectedFile, setSelectedFile] = useState(null);
	const [platform, setOptionSelector] = useState('Foresight');

	const handlePlatformChange = (method) => {
		setOptionSelector(method);
	};
	const MenuItems = [
		{ value: 'invalid', disabled:true, text: 'Select one option' }, 
		{ value: 'Foresight', disabled:false, text: 'Foresight' }, 
		{ value: 'PrOptima', disabled:true, text: 'PrOptima' },
	];

	const handleFileChange = (e) => {
		setSelectedFile(e.target.files[0]);
		setFileName(e.target.files[0].name);
	};

	const handleSubmit = async () => {
		if (!selectedFile) {
			dispatch(enqueueSnackbar({ message: 'Please select a file.', options: { variant: 'error' } }));
			return;
		}

		const formData = new FormData();
		formData.append('File', selectedFile);
		formData.append('UserId', userId);
		formData.append('Platform', platform);

		try {
			const data = await VTKDataRefreshAction(formData); // Chama a action para excluir
			dispatch(enqueueSnackbar({ message: data.message, options: { variant: 'success' } }));
			
			setOptionSelector('Foresight');// Limpa a seleção
			setSelectedFile(''); // Limpa a seleção
			setFileName(''); // Limpa a seleção
		} catch (error) {
			dispatch(enqueueSnackbar({ message: `${error}`, options: { variant: 'error' } }));
		}
	};

	return (
		<Grid2 container spacing={2}>
			<Grid2 item size={12}>
				<Typography variant="body2" align='center' sx={{ color: 'text.secondary' }}>
					Please select a pair of files to load belonging to the same technology, network side and covering the same list of consecutive days.
					{/* <br />Use the reports saved in folder //everybody/Celfinet/AutoReports2020 of the PrOptima platform. */}
					<br />Beware that once the above criteria are met, the manual upload will substitute the content of the tables underlying the S12 Monitoring Dashboards.
					<br />
					<br /><strong><underline>Proceed at your own risk.</underline></strong>
				</Typography>
			</Grid2>
			<Grid2 item size={12}>
				<SelectField
					id="inputPlatform"
					name="inputPlatform"
					value={platform}
					onChange={(e) => handlePlatformChange(e.target.value)}
					hintText="Platform"
					menuItems={MenuItems}
				/>
			</Grid2>
			<Grid2 item size={12}>
				<TextField
					label="File Name"
					variant="outlined"
					fullWidth
					InputProps={{
						readOnly: true,
						disabled: true
					}}
					value={fileName} />
			</Grid2>
			<Grid2 item size={12}>
				<Tooltip
					title={
						<Box
							component="table"
							sx={{
								//backgroundColor: "white",
								border: "1px solid #ccc",
								boxShadow: 1,
								p: 1,
								borderRadius: 1,
								"& td": { padding: "4px 8px" },
							}}
						>
							<tbody>
								<tr>
									<td>
										<h2>Files must contain the following nomenclature</h2>
										<br></br>
										<h3><underline>(Side: TFinTF, VFinTF or TFinVF)</underline></h3>
									</td>
								</tr>
								{[
									"VTK_S12_2G_Side_part1*.csv",
									"VTK_S12_2G_Side_part2*.csv",
									"VTK_S12_3G_Side_part1*.csv",
									"VTK_S12_3G_Side_part2*.csv",
									"VTK_S12_4G_Side_part1_Ericsson*.csv",
									"VTK_S12_4G_Side_part2_Ericsson*.csv",
									"VTK_S12_4G_Side_part1_Nokia*.csv",
									"VTK_S12_4G_Side_part2_Nokia*.csv",
									"",
									"VTK_2G_Side_B3_Cell_List*.csv",
									"VTK_3G_Side_B3_Cell_List*.csv",
									"VTK_4G_Side_B3_Cell_List*.csv"
								].map((name, idx) => (
									<tr key={idx}>
										<td>{name}</td>
									</tr>
								))}
							</tbody>
						</Box>
					}
					placement="right"
					arrow
				>
					<Button variant="contained" component="label" fullWidth startIcon={<UploadFileIcon />}>
						Upload File
						<input type="file" accept='.zip, .csv' hidden onChange={handleFileChange} />
					</Button>
				</Tooltip>
			</Grid2><Grid2 item size={12}>
				<Button variant="contained" color="primary" fullWidth onClick={handleSubmit}>
					Submit
				</Button>
			</Grid2>
		</Grid2>
	);
};

export default VTKDataRefreshForm;